import React, { useEffect, useState, useMemo } from "react";
import { FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { TbBallpen } from "react-icons/tb";
import "react-phone-input-2/lib/style.css";
import { NavLink } from "react-router-dom";
import apiKey from "../../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const typeIdToOption = {
  1: "home",
  2: "online",
  3: "both",
};

const AddSubject = () => {
  const { t } = useTranslation();
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  const Id = teacher?.teacher?.id || "";
  const [typeId, setTypeId] = useState(null);
  const [selectedOption, setSelectedOption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [mySubjects, setMySubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [id, setId] = useState(null);
  const [editclass, setEditClass] = useState("");
  const [edithome, setEditHome] = useState("");
  const [editCharge, setEditCharge] = useState("");
  const [edit, setEdit] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);

  const [formData, setFormData] = useState({
    class_id: "",
    subjects: [],
    type_id: typeId,
    online_charges: "",
    home_charges: "",
  });

  const initialFormData = {
    class_id: "",
    subjects: [],
    type_id: typeId,
    online_charges: "",
    home_charges: "",
  };

  // ====== FETCH DATA ======
  useEffect(() => {
    setLoading(true);
    Promise.all([
      axios.get(`${apiKey}/api/edolutions/teacher/classes`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      }),
      axios.get(`${apiKey}/api/edolutions/teacher/subject-wp`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      }),
      axios.get(`${apiKey}/api/edolutions/teacher/gettype/${Id}`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      }),
    ])
      .then(([cls, subs, type]) => {
        setClasses(cls.data);
        setMySubjects(subs.data);
        const fetchedTypeId = type.data.type_id;
        setTypeId(fetchedTypeId);
        setSelectedOption(typeIdToOption[fetchedTypeId] || "");
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [teacher?.token, Id]);

  useEffect(() => {
    if (typeId !== null)
      setFormData((prev) => ({ ...prev, type_id: typeId }));
  }, [typeId]);

  useEffect(() => {
    if (formData.class_id) {
      axios
        .get(`${apiKey}/api/edolutions/teacher/classes/${formData.class_id}`, {
          headers: { Authorization: `Bearer ${teacher?.token}` },
        })
        .then((res) => setSubjects(res.data))
        .catch(console.error);
    }
  }, [formData.class_id, teacher?.token]);

  const options = subjects.map((item) => ({
    value: item.subject_id,
    label: item.subject_name,
  }));

  const groupedSubjects = useMemo(() => {
    const groups = {};
    mySubjects.forEach((subject) => {
      if (!groups[subject.id]) groups[subject.id] = [];
      groups[subject.id].push(subject);
    });
    return groups;
  }, [mySubjects]);

  // ====== HANDLERS ======
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleChangeSub = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    const existingIds = mySubjects.map((s) => s.subject_id);
    const filtered = selectedValues.filter((v) => !existingIds.includes(v));
    setErrorMessage(
      filtered.length !== selectedValues.length
        ? t("teacherDash.addSubject.someSubjectsRemoved")
        : ""
    );
    setSelectedOptions(
      selectedOptions.filter((opt) => !existingIds.includes(opt.value))
    );
    setFormData({ ...formData, subjects: filtered });
  };

  const refreshSubjects = () => {
    axios
      .get(`${apiKey}/api/edolutions/teacher/subject-wp`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      })
      .then((res) => setMySubjects(res.data))
      .catch(console.error);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    axios
      .post(`${apiKey}/api/edolutions/teacher/subject-wp`, formData, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          style: { background: "#2A3A54", color: "#fff" },
        });
        setFormData(initialFormData);
        setSelectedOptions([]);
        setShowModal(false);
        refreshSubjects();
      })
      .catch((err) => {
        setErrors(err.response?.data?.data || {});
      })
      .finally(() => setIsLoading(false));
  };

  const handleDeleteSubject = (id) => {
    axios
      .delete(`${apiKey}/api/edolutions/teacher/subject-wp/${id}`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          style: { background: "#EE5F2B", color: "#fff" },
        });
        refreshSubjects();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message, {
          position: "bottom-right",
          style: { background: "#2A3A54", color: "#fff" },
        });
      });
  };

  const handleFunctionEdit = (
    id,
    subject_name,
    class_name,
    home_charges,
    online_charges
  ) => {
    setId(id);
    setEditClass(class_name);
    setEditHome(home_charges);
    setEditCharge(online_charges);
    setShowModalEdit(true);

    axios
      .get(`${apiKey}/api/edolutions/teacher/subject-wp/${id}`, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      })
      .then((res) => {
        const defaultSubs = res.data.map((sub) => ({
          value: sub.subject_id,
          label: sub.subject_name,
        }));
        setSelectedOptions(defaultSubs);
        setEdit(res.data);
        setFormData({
          class_id: res.data[0].class_id,
          type_id: res.data[0].type_id,
          online_charges: res.data[0].online_charges,
          home_charges: res.data[0].home_charges,
          subjects: defaultSubs.map((d) => d.value),
        });
      })
      .catch(console.error);
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault();
    setIsLoading2(true);
    axios
      .put(`${apiKey}/api/edolutions/teacher/subject-wp/${id}`, formData, {
        headers: { Authorization: `Bearer ${teacher?.token}` },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          style: { background: "#2A3A54", color: "#fff" },
        });
        setShowModalEdit(false);
        refreshSubjects();
      })
      .catch((err) => setErrors(err.response?.data?.data || {}))
      .finally(() => setIsLoading2(false));
  };

  // ====== UI COMPONENTS ======
  const GradientButton = ({ onClick, children, disabled }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]
        text-white font-semibold text-sm px-5 py-2 rounded-lg shadow-sm transition-all ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
    >
      {children}
    </button>
  );

  // ====== MAIN RETURN ======
  return (
    <div className="flex items-center xl:p-5 sm:p-0 justify-center">
      <div className="w-full border rounded-3xl shadow-xl p-6 px-8 bg-white">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-800">{t("teacherDash.common.settings")}</h1>
          <GradientButton onClick={() => setShowModal(true)}>
            <FaPlus className="inline mr-2" /> {t("teacherDash.common.add")}
          </GradientButton>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-6 border-b pb-3 text-sm font-semibold text-gray-600 mb-5">
          <NavLink
            to=".././profile-setting-tech"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                : "hover:text-[#2A3A54]"
            }
          >
            {t("teacherDash.settingTabs.profileSettings")}
          </NavLink>
          <span className="text-[#EE5F2B] border-b-2 border-[#EE5F2B]">
            {t("teacherDash.settingTabs.specializationsWp")}
          </span>
          <NavLink
            to=".././other-detail"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                : "hover:text-[#2A3A54]"
            }
          >
            {t("teacherDash.settingTabs.otherDetails")}
          </NavLink>
          <NavLink
            to=".././security"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
                : "hover:text-[#2A3A54]"
            }
          >
            {t("teacherDash.settingTabs.privacySecurity")}
          </NavLink>
        </div>

        <h2 className="text-lg font-semibold mb-4">
          {t("teacherDash.addSubject.heading")}
        </h2>

        {/* List */}
        {loading ? (
          <div className="text-center py-6 text-gray-500">{t("teacherDash.common.loading")}</div>
        ) : Object.entries(groupedSubjects).length === 0 ? (
          <p className="text-center text-gray-500 py-4">
            {t("teacherDash.addSubject.noSpecializations")}
          </p>
        ) : (
          <div className="grid md:grid-cols-3 gap-4 mt-3">
            {Object.entries(groupedSubjects).map(([id, subjects]) => (
              <div
                key={id}
                className="p-5 border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition"
              >
                <h3 className="font-semibold text-lg text-gray-800">
                  {subjects[0].class_name}
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  {subjects.map((s) => s.subject_name).join(" | ")}
                </p>
                {(typeId === 2 || typeId === 3) && (
                  <p className="text-xs text-gray-500 mt-2">
                    {t("teacherDash.addSubject.chargesPrefix")}{t("teacherDash.homeTution.currencyPrefix")}{subjects[0].online_charges}
                  </p>
                )}
                <div className="flex items-center gap-3 mt-4 text-lg">
                  <TbBallpen
                    onClick={() =>
                      handleFunctionEdit(
                        subjects[0].id,
                        subjects[0].subject_name,
                        subjects[0].class_name,
                        subjects[0].home_charges,
                        subjects[0].online_charges
                      )
                    }
                    className="text-[#2A3A54] cursor-pointer"
                  />
                  <FaRegTrashAlt
                    onClick={() => handleDeleteSubject(subjects[0].id)}
                    className="text-red-600 cursor-pointer"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ====== ADD MODAL ====== */}
      {showModal && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40"></div>
          <div className="fixed inset-0 z-50 flex justify-center items-center px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-lg relative">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-black"
              >
                ×
              </button>
              <h2 className="text-2xl font-bold text-center mb-4">
                {t("teacherDash.addSubject.addSubjectTitle")}
              </h2>

              <form onSubmit={handleSubmit}>
                {/* Class */}
                <label className="text-sm font-semibold mt-2 block">
                  {t("teacherDash.common.classLabelPlain")}
                </label>
                <select
                  name="class_id"
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                >
                  <option value="">{t("teacherDash.addSubject.selectClassOption")}</option>
                  {classes.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.class_name}
                    </option>
                  ))}
                </select>

                {/* Subject */}
                <label className="text-sm font-semibold mt-3 block">
                  {t("teacherDash.common.subject")}
                </label>
                <Select
                  options={options}
                  isMulti
                  value={selectedOptions}
                  onChange={handleChangeSub}
                  closeMenuOnSelect={false}
                  styles={{
                    multiValue: (base) => ({
                      ...base,
                      background: "#EE5F2B",
                      color: "white",
                    }),
                    multiValueLabel: (base) => ({ ...base, color: "#fff" }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#fff",
                      ":hover": { background: "#2A3A54", color: "#fff" },
                    }),
                  }}
                />
                {errorMessage && (
                  <p className="text-xs text-red-500 mt-1">{errorMessage}</p>
                )}

                {/* Charges */}
                {selectedOption === "online" && (
                  <div>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesOnlineLabel")}
                    </p>
                    <input
                      name="online_charges"
                      onChange={handleChange}
                      value={formData.online_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </div>
                )}
                {selectedOption === "home" && (
                  <div>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesHomeLabel")}
                    </p>
                    <input
                      name="home_charges"
                      onChange={handleChange}
                      value={formData.home_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </div>
                )}
                {selectedOption === "both" && (
                  <>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesOnlineLabel")}
                    </p>
                    <input
                      name="online_charges"
                      onChange={handleChange}
                      value={formData.online_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesHomeLabel")}
                    </p>
                    <input
                      name="home_charges"
                      onChange={handleChange}
                      value={formData.home_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </>
                )}

                <div className="flex justify-center mt-6">
                  <GradientButton disabled={isLoading}>
                    {isLoading ? t("teacherDash.common.saving") : t("teacherDash.common.save")}
                  </GradientButton>
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      {/* ====== EDIT MODAL ====== */}
      {showModalEdit && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40"></div>
          <div className="fixed inset-0 z-50 flex justify-center items-center px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-lg relative">
              <button
                onClick={() => setShowModalEdit(false)}
                className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-black"
              >
                ×
              </button>
              <h2 className="text-2xl font-bold text-center mb-4">
                {t("teacherDash.addSubject.editSubjectTitle")}
              </h2>

              <form onSubmit={handleSubmitEdit}>
                {/* Class */}
                <label className="text-sm font-semibold mt-2 block">
                  {t("teacherDash.common.classLabelPlain")}
                </label>
                <select
                  name="class_id"
                  onChange={handleChange}
                  value={formData.class_id}
                  className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                >
                  <option value="">{t("teacherDash.addSubject.selectClassOption")}</option>
                  {classes.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.class_name}
                    </option>
                  ))}
                </select>

                {/* Subject */}
                <label className="text-sm font-semibold mt-3 block">
                  {t("teacherDash.common.subject")}
                </label>
                <Select
                  options={options}
                  isMulti
                  value={selectedOptions}
                  onChange={handleChangeSub}
                  closeMenuOnSelect={false}
                  styles={{
                    multiValue: (base) => ({
                      ...base,
                      background: "#EE5F2B",
                      color: "white",
                    }),
                    multiValueLabel: (base) => ({ ...base, color: "#fff" }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#fff",
                      ":hover": { background: "#2A3A54", color: "#fff" },
                    }),
                  }}
                />

                {/* Charges */}
                {selectedOption === "online" && (
                  <div>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesOnlineLabel")}
                    </p>
                    <input
                      name="online_charges"
                      onChange={handleChange}
                      value={formData.online_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </div>
                )}
                {selectedOption === "home" && (
                  <div>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesHomeLabel")}
                    </p>
                    <input
                      name="home_charges"
                      onChange={handleChange}
                      value={formData.home_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </div>
                )}
                {selectedOption === "both" && (
                  <>
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesOnlineLabel")}
                    </p>
                    <input
                      name="online_charges"
                      onChange={handleChange}
                      value={formData.online_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                    <p className="mt-3 text-sm font-medium">
                      {t("teacherDash.addSubject.chargesHomeLabel")}
                    </p>
                    <input
                      name="home_charges"
                      onChange={handleChange}
                      value={formData.home_charges}
                      className="w-full rounded-lg border border-gray-200 bg-[#F9FBFF] px-3 py-2 mt-1"
                      placeholder={t("teacherDash.addSubject.chargesPlaceholder")}
                    />
                  </>
                )}

                <div className="flex justify-center mt-6">
                  <GradientButton disabled={isLoading2}>
                    {isLoading2 ? t("teacherDash.common.updating") : t("teacherDash.common.update")}
                  </GradientButton>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddSubject;
